var render = function render() {
  var _vm$header, _vm$body, _vm$footer, _vm$header2, _vm$body2, _vm$footer2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "table-alt"
  }, [_vm._l((_vm$header = _vm.header) === null || _vm$header === void 0 ? void 0 : _vm$header.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticClass: "table-alt-row-header",
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  }), _vm._v(" "), _vm._l((_vm$body = _vm.body) === null || _vm$body === void 0 ? void 0 : _vm$body.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticClass: "table-alt-body",
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  }), _vm._v(" "), ((_vm$footer = _vm.footer) === null || _vm$footer === void 0 ? void 0 : _vm$footer.rows.length) > 0 ? _c('div', _vm._l(_vm.footer.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row table-alt-row__final table-alt-footer"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticStyle: {
          "font-size": "27px"
        },
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  }), 0) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "table-alt table-alt-mobile"
  }, [_vm._l((_vm$header2 = _vm.header) === null || _vm$header2 === void 0 ? void 0 : _vm$header2.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticClass: "table-alt-row-header",
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  }), _vm._v(" "), _vm._l((_vm$body2 = _vm.body) === null || _vm$body2 === void 0 ? void 0 : _vm$body2.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticClass: "table-alt-body",
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  }), _vm._v(" "), _vm._l((_vm$footer2 = _vm.footer) === null || _vm$footer2 === void 0 ? void 0 : _vm$footer2.rows, function (row) {
    return _c('div', {
      key: row._key,
      staticClass: "table-alt-row__final table-alt-footer"
    }, _vm._l(row.cells, function (cell) {
      return _c('div', {
        key: cell._key,
        staticClass: "table-alt-col",
        class: [_vm.alignment],
        style: {
          'padding-top': cell.paddingTop > 0 && `${cell.paddingTop}px`
        }
      }, [_c('sanity-block-content', {
        staticStyle: {
          "font-size": "27px"
        },
        attrs: {
          "blocks": cell.blocks
        }
      })], 1);
    }), 0);
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };